const LOAD_DETAIL_CANDIDATE           = 'LOAD_DETAIL_CANDIDATE'
const LOAD_DETAIL_CANDIDATE_SUCCESS   = 'LOAD_DETAIL_CANDIDATE_SUCCESS'
const LOAD_DETAIL_CANDIDATE_FAILED    = 'LOAD_DETAIL_CANDIDATE_FAILED'
const UNMOUNT_DETAIL_CANDIDATE        = 'UNMOUNT_DETAIL_CANDIDATE'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const candidateDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_CANDIDATE:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_CANDIDATE_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_CANDIDATE_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_CANDIDATE:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default candidateDetailReducer;